module.exports = __webpack_public_path__ + "static/media/StatTapsCircle.6cc2f5b3.svg";